import { useNovaApi } from '../useNovaApi';

export const usePROEarningsQuarters = () => {
  return (
    useNovaApi<Nl.Api.PROEarningsQuartersResponse>(
      '/pro_earnings_statement/quarter_select',
    ).data?.pro_earnings_statements || []
  );
};
